import React from "react"; 

function TermsAndConditions() {
  return (
    <div className="container mt-4 mt-lg-5">
      <h4>Terms & Conditions</h4>
      <p>
        Welcome to <strong>EthiocarHub</strong>. By accessing or using our platform, 
        you agree to abide by the following terms and conditions.
      </p>
      <p>
        Users must provide accurate information when posting vehicles. 
        EthiocarHub is not responsible for any inaccuracies in listings, 
        pricing, or transactions between buyers and sellers.
      </p>
      <p>
        We reserve the right to update these terms at any time to ensure fair use of the platform.
      </p>
    </div>
  );
}

export default TermsAndConditions;
